import AdditionalService from '@/components/AdditionalService'




import Head from 'next/head'
import Hero from '@/components/Hero'
import StepsSection from '@/components/StepsSection'
import FAQ from '@/components/FAQ'
import CookieConsent from '@/components/CookieConsent'
import Image from 'next/image'
import SubmitForm from '@/components/SubmitForm'

import AdvantageComponent from '@/components/AdvantageComponent'
import ContentSection from '@/components/ContentSection'


export default function Home({ faqs }: any) {
  const city = "Sankt Augustin";
  const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL || 'https://www.autoverwertung-sankt-augustin24.de'
  const cloudflareSiteKey = process.env.NEXT_PUBLIC_CLOUDFLARE_SITE_KEY || ''
  const canonicalUrl = BASE_URL.match(/^https?:\/\/www\./i)
    ? BASE_URL.replace(/^https?:\/\/www\./i, (match) => match.replace('www.', ''))
    : BASE_URL.replace(/^(https?:\/\/)/i, '$1www.')

  return (
    <>
      <Head>
        <title>Autoverwertung Sankt Augustin & Autoentsorgung Sankt Augustin | Schnell & Fachgerecht</title>
        <meta name="description" content={`Autoverwertung Sankt Augustin & Autoentsorgung. ✓ Kostenlose Abholung ✓ Verwertungsnachweis ✓ Ankauf von Unfallfahrzeugen ✓ Barzahlung vor Ort.`} />
        <meta property="og:title" content={`Autoverwertung Sankt Augustin & Autoentsorgung Sankt Augustin | Schnell & Fachgerecht`} />
        <meta property="og:description" content={`Professionelle Autoverwertung Sankt Augustin & Autoentsorgung Sankt Augustin ✓ Kostenlose Abholung ✓ Verwertungsnachweis ✓ Ankauf von Unfallfahrzeugen ✓ Barzahlung vor Ort.`} />
        <meta property="og:image" content="/images/cars/hero.webp" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={BASE_URL} />
        <link rel="canonical" href={canonicalUrl} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`Autoverwertung Sankt Augustin & Autoentsorgung Sankt Augustin | Schnell & Fachgerecht`} />
        <meta name="twitter:description" content={`Professionelle Autoverwertung Sankt Augustin & Autoentsorgung Sankt Augustin ✓ Kostenlose Abholung ✓ Verwertungsnachweis ✓ Ankauf von Unfallfahrzeugen ✓ Barzahlung vor Ort.`} />
        <meta name="twitter:image" content="/images/cars/hero.webp" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta charSet="UTF-8" />
        <meta lang='de' />
        {/* Schema.org LD+JSON for first 4 cities */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify([
            {
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": `Autoverwertung Sankt Augustin`,
              "image": "/images/cars/hero.webp",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": city,
                "addressCountry": "DE"
              },
              "description": `Autoverwertung Sankt Augustin & Autoentsorgung Sankt Augustin ✓ Kostenlose Abholung ✓ Verwertungsnachweis ✓ Ankauf von Unfallfahrzeugen ✓ Barzahlung vor Ort.`,
              "url": `${process.env.NEXT_PUBLIC_BASE_URL_WITH_WWW}`
            },
          ])
        }} />
      </Head>

      {/* Mobile: SubmitForm above Hero */}
      <Hero city={city} />

      {/* Content Section: Einfache Lösungen für Ihren Verkauf */}

      <div className="block md:hidden bg-white">
        <div className="w-16 h-12 bg-primary-light rounded-b-2xl mx-auto  shadow-lg" ></div>
        <div className="flex justify-center -mt-8 mb-2" onClick={() => {
          const form = document.getElementById('contact-form');
          if (form) {
            form.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }}>
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#215E61"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="animate-bounce"
            aria-hidden="true"
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </div>
        <section id="Kontaktdaten" className="container mx-auto px-4 relative z-20 mt-2">
          {/* Connection shape between Hero and SubmitForm (mobile) */}


          <div   className="w-full max-w-4xl mx-auto rounded-2xl shadow-2xl border border-primary-light bg-white/80 p-4 md:p-8 animate-fadeIn">
            <SubmitForm cloudflareSiteKey={cloudflareSiteKey} />
          </div>
        </section>
      </div>

      {/* Desktop: Connection point and SubmitForm below Hero */}
      <div id="Kontaktdaten" className="hidden md:block bg-white">
        {/* Connection point */}
        <div className="w-full flex justify-center">
          <div className="w-16 h-12 bg-primary-light rounded-b-2xl mx-auto  shadow-lg" />
        </div>
        <section  className="container mx-auto px-4 relative z-20 mt-8  ">
          <div className="w-full max-w-4xl mx-auto rounded-2xl shadow-2xl border border-primary-light bg-primary/10 p-4 md:p-8 animate-fadeIn">
            <SubmitForm cloudflareSiteKey={cloudflareSiteKey} />
          </div>



        </section>
      </div>



      <StepsSection city={city} />

      <ContentSection
        id="einfache-loesungen"
        title={`Einfache Lösungen für Ihren Verkauf – mit der Autoverwertung in ${city || "Sankt Augustin"}`}
        description={[
          "Bei der Autoverwertung Sankt Augustin vereinfachen wir den Verkaufsprozess erheblich: Senden Sie uns einfach die Fahrzeugdaten, und wir liefern eine transparente Bewertung. Im Anschluss stimmen Sie einen Abholtermin mit uns ab, der kostenlos ist. Bei der Übergabe erhalten Sie umgehend Ihre Auszahlung.",
          "Anstelle von mühsamen Inseraten und unzähligen Preisverhandlungen, die oft in Absagen enden, bringen wir Ihnen ein klares und nachvollziehbares Angebot für die Kfz-Entsorgung. Wenn Sie nach einem Schrottplatz in der Nähe suchen, erhalten Sie bei uns eine schnelle und transparente Lösung.",
          "Das Angebot eignet sich hervorragend, wenn Sie ein Altauto entsorgen, ein Unfallfahrzeug abgeben, einen Gebrauchten ohne HU loswerden oder einfach Ihr Fahrzeug kaputt verkaufen möchten. Wenn Sie denken: Ich möchte mein Auto los werden, unterstützen wir Sie schnell und unkompliziert. Auch im Bereich Autoverschrottung Sankt Augustin stehen wir Ihnen mit unserer langjährigen Erfahrung zur Seite. Vertrauen Sie auf unsere Expertise in der Autoverwertung Sankt Augustin und profitieren Sie von einem unkomplizierten Verkaufsprozess!"
        ]}
        image={"/images/cars/2.jpeg"}
      />    

      <ContentSection
        id="welche-fahrzeuge-uebernimmt"
        title={`Welche Fahrzeuge die Autoverwertung in ${city || "Sankt Augustin"} übernimmt – von Teileträger bis Motorschaden`}
        description={[`Bei der Autoverwertung in ${city || "Sankt Augustin"} sehen wir fast jedes Fahrzeug als wertvoll an – sei es ein Unfallwagen oder ein Altauto ohne TÜV.`, ` Wir prüfen sorgfältig den Teilewert und leiten eine rechtssichere Kfz-Entsorgung ein. Auch wenn Anbauteile fehlen, der Innenraum beschädigt ist oder Ihr Fahrzeug seit längerer Zeit nicht mehr bewegt wurde, sind wir bereit, den Schrottauto-Ankauf zu evaluieren. Eine ehrliche Beschreibung des Ist-Zustandes ist dabei entscheidend. `, `Abgemeldete Pkw, Langsteher mit Rost an tragenden Teilen, Fahrzeuge mit Elektrikdefekten sowie leichte Nutzfahrzeuge und Transporter gehören ebenfalls zu unserem Serviceangebot. Kurz gesagt: Wenn Sie Ihr Kfz entsorgen und dabei Geld verdienen möchten, starten Sie jetzt unsere Online-Fahrzeugbewertung bei der Autoverwertung Sankt Augustin!`]}
        image={"/images/cars/3.jpeg"}
      />

      <ContentSection
        id="welche-fahrzeuge-uebernimmt-2"
        title={`Welche Fahrzeuge ? die Autoverwertung in ${city || "Sankt Augustin"} übernimmt – Teileträger bis Motorschaden`}
        description={[`Bei der Autoverwertung in ${city || "Sankt Augustin"} sehen wir fast jedes Fahrzeug als wertvoll an – sei es ein Unfallwagen oder ein Altauto ohne TÜV.`, ` Wir prüfen sorgfältig den Teilewert und leiten eine rechtssichere Kfz-Entsorgung ein. Auch wenn Anbauteile fehlen, der Innenraum beschädigt ist oder Ihr Fahrzeug seit längerer Zeit nicht mehr bewegt wurde, sind wir bereit, den Schrottauto-Ankauf zu evaluieren. Eine ehrliche Beschreibung des Ist-Zustandes ist dabei entscheidend. `, `Abgemeldete Pkw, Langsteher mit Rost an tragenden Teilen, Fahrzeuge mit Elektrikdefekten sowie leichte Nutzfahrzeuge und Transporter gehören ebenfalls zu unserem Serviceangebot. Kurz gesagt: Wenn Sie Ihr Kfz entsorgen und dabei Geld verdienen möchten, starten Sie jetzt unsere Online-Fahrzeugbewertung bei der Autoverwertung Sankt Augustin!`]}
    image={"/images/cars/4.png"}
      />

      <ContentSection
        id="transparente-preisgestaltung"
        title={`Transparente Preisgestaltung – Was den Wert bei der Autoentsorgung in ${city || "Sankt Augustin"} bestimmt`}
        description={[
          `Bei der Autoverwertung in ${city || "Sankt Augustin"} basiert unsere Wertermittlung auf verschiedenen entscheidenden Faktoren: Substanz, Laufleistung, Antrieb/Abgasnorm, Getriebe und Ausstattung des Fahrzeugs. Darüber hinaus berücksichtigen wir oft unterschätzte Aspekte, die den Preis bei der Autoentsorgung beeinflussen.`
          , `Wichtige Kriterien sind der Teilewert und der Demontageaufwand. Wirtschaftlich ausbaubare Aggregate und Karosserieteile können den Erlös erhöhen, während aufwendige Trennarbeiten diesen mindern. Auch die Dokumentation spielt eine wichtige Rolle: Vollständige Fahrzeugpapiere, eine stimmige VIN und komplette Schlüssel beschleunigen die Abwicklung und steigern den Wert.`
          , `Zudem fließt der Materialmix und die Verwertungsquote in die Kalkulation ein. Sortenrein trennbare Metalle und vollständige Anbauteile wirken sich positiv auf den Gesamtwert aus. Vertrauen Sie auf unsere Expertise in der Autoverwertung in ${city || 'Sankt Augustin'} und lassen Sie sich von einer fairen Preisgestaltung überzeugen!`

        ]}
        image={"/images/cars/1.jpeg"}
      />
      <ContentSection
        id="so-funktioniert"
        title="So funktioniert die Autoverwertung Sankt Augustin – Mit wenigen Klicks zum Verkauf"
        description={[
          "Online anfragen: Geben Sie relevante Informationen wie Marke, Modell, Baujahr, Laufleistung, Zustand und Standort in unser Online-Formular ein.",
          "Angebot erhalten: Sie erhalten zeitnah von uns ein unverbindliches, marktgerechtes Angebot.",
          "Termin wählen: Sind Sie mit den Konditionen zufrieden, vereinbaren Sie einfach einen Abholtermin mit uns.",
          "Übergabe & Auszahlung: Vor Ort überprüfen wir kurz Ihr Fahrzeug und die Unterlagen, zahlen den vereinbarten Betrag aus und übernehmen Ihr Auto in die Autoverwertung.",
          "Profitieren Sie von einem schnellen und unkomplizierten Prozess der Autoverwertung Sankt Augustin!"
        ]}
            image={"/images/cars/5.png"}
      />

      <ContentSection
        id="alle-unterlagen"
        title="Alle Unterlagen aus einer Hand – Mit der Autoverwertung Sankt Augustin"
        description={[
          "Zum vereinbarten Termin bringen wir alle notwendigen Unterlagen für Sie vollständig vorbereitet mit: Dazu gehört ein rechtswirksamer Kaufvertrag sowie ein detailliertes Übergabeprotokoll, in dem wir Kilometerstand, Anzahl der Schlüssel, übergebene Dokumente und den vereinbarten Auszahlungsbetrag festhalten – inklusive Zubehör und besonderen Hinweisen.",
          "Die Abmeldung bei der Zulassungsstelle übernehmen wir standardmäßig für Sie, und die amtliche Bestätigung erhalten Sie digital. Falls Sie weitere Nachweise benötigen, beispielsweise für Ihren Arbeitgeber oder eine Behörde, stellen wir auf Wunsch ein ergänzendes Dokumentenpaket bereit.",
          "So gestalten wir Ihren Verkauf vollständig, prüfbar und lückenlos – ganz ohne, dass Sie selbst Formulare oder Wege organisieren müssen. Vertrauen Sie auf die Autoverwertung Sankt Augustin für einen stressfreien Verkaufsprozess!"
        ]}
            image={"/images/cars/6.png"}
      />


      <AdvantageComponent sectionId="vorteile" />

      <ContentSection
        id="effiziente-logistik"
        title="Abholung und Verladung bei der Autoverwertung Sankt Augustin"
        description={[
          "Für die Autoverwertung Sankt Augustin genügt in der Regel ein normal zugänglicher Stellplatz. Nach kurzer Abstimmung kommen wir auch zu Tiefgaragen, Hinterhöfen oder Firmengeländen und klären im Voraus wichtige Details wie Einfahrtshöhen, Kurvenradien, Rangierflächen und mögliche Haltezeiten. Sollte das Fahrzeug nicht fahrbereit sein, planen wir die Verladung mit der entsprechenden Technik.",
          "Durch unsere optimierten Touren in der Region koordinieren wir die Abholung in Sankt Augustin häufig gemeinsam mit Städten wie Kitzingen, Ochsenfurt, Karlstadt oder Schweinfurt. So halten wir die Wege kurz und gewährleisten zeitnahe Termine. Auch im Bereich Autoverschrottung Sankt Augustin profitieren Sie von unserer flexiblen Planung und einer zuverlässigen Organisation.",
          "Vertrauen Sie auf unsere professionelle Logistik bei der Autoverwertung Sankt Augustin und profitieren Sie von einem reibungslosen Ablauf!"
        ]}
            image={"/images/cars/7.png"}
      />  

      <ContentSection
        id="pragmatische-loesungen"
        title="Pragmatische Lösungen für Sonderfälle – Autoverwertung Sankt Augustin bei fehlenden Papieren und Finanzierung"
        description={[
          "Wenn Unterlagen fehlen, klären wir gemeinsam die besten Optionen, wie z.B. Verlustanzeigen oder Ersatzdokumente. Bei laufender Finanzierung oder Leasing nehmen wir direkt Kontakt mit Ihrer Bank oder dem Leasinggeber auf, um die Freigabe zu koordinieren und zahlen gemäß den Vorgaben aus.",
          "Für Fahrzeuge mit ausländischen Papieren prüfen wir, welche zusätzlichen Nachweise erforderlich sind, beispielsweise Kaufbelege oder Einfuhrunterlagen. Wir führen Sie strukturiert durch die nächsten Schritte, damit der Prozess reibungslos verläuft.",
          "Vertrauen Sie auf die Autoverwertung Sankt Augustin, um Sonderfälle professionell und unkompliziert zu lösen!"
        ]}
            image={"/images/cars/8.jpeg"}
      />

      <ContentSection
        id="effiziente-fahrzeugentsorgung"
        title="Effiziente Fahrzeugentsorgung für Gewerbekunden und Fuhrparks in der Autoverwertung Sankt Augustin"
        description={[
          "Für Unternehmen bündeln wir mehrere Fahrzeuge zu einem Termin, was Standzeiten erheblich reduziert. Zudem arbeiten wir mit festen Ansprechpartnern, sodass Sie jederzeit einen direkten Kontakt haben. Alle Dokumente, einschließlich Rechnungen, erhalten Sie digital und revisionssicher für Ihre Buchhaltung.",
          "Der größte Vorteil für Sie: Weniger Abstimmungsschleifen und planbare Prozesse mit festen Zeitfenstern. Dadurch sinken sowohl Stand- als auch Opportunitätskosten. Außerdem stellen wir sicher, dass alle Nachweise in einheitlicher Struktur vorliegen, was Abschlüsse beschleunigt und interne Prüfungen deutlich vereinfacht.",
          "Profitieren Sie von der effizienten Fahrzeugentsorgung in der Autoverwertung Sankt Augustin und optimieren Sie Ihre Abläufe!"
        ]}
            image={"/images/cars/9.jpeg"}
      />

      <ContentSection
        id="privat-verschrotten"
        title="Privat verschrotten oder an Schrotthändler verkaufen? – Die Autoverwertung Sankt Augustin spart Zeit"
        description={[
          "Eine Autoverschrottung in Eigenregie bedeutet oft: Abschleppen, Entsorger suchen, Preise vergleichen, Termine koordinieren und Nachweise zusammentragen – häufig verbunden mit unklaren Nebenkosten. Wer stattdessen einen Schrottplatz in der Nähe sucht, möchte in der Regel vor allem Zeit und Aufwand sparen.",
          "Bei der Autoverwertung Sankt Augustin läuft alles in einem Schritt ab: Wir bieten Ihnen einen Schrottauto-Ankauf, übernehmen die kostenlose Abholung, kümmern uns um die Verschrottung, die Abmeldung und zahlen bei der Übergabe den vereinbarten Betrag aus. Und das alles mit einem verbindlichen Preis und vollständigen Belegen.",
          "Vertrauen Sie auf unseren Service und sparen Sie Zeit und Aufwand bei der Fahrzeugverwertung!"
        ]}
            image={"/images/cars/10.jpeg"}
      />
      <ContentSection
        id="verantwortungsbewusster-umgang"
        title="Verantwortungsbewusster Umgang mit Oldtimern, Youngtimern und Teileträgern – Autoverwertung Sankt Augustin"
        description={[
          "Nicht jedes alte Fahrzeug gehört in die Presse. Bei der Autoverwertung Sankt Augustin prüfen wir, ob eine Erhaltung sinnvoll ist, insbesondere bei gesuchten Baureihen und Modellen.",
          "Wenn die Verwertung dennoch die beste Lösung ist, garantieren wir, dass wertvolle Komponenten als Ersatzteile erhalten bleiben und Ressourcen verantwortungsvoll in den Kreislauf zurückfließen. Auch im Bereich Autoverschrottung Sankt Augustin achten wir darauf, möglichst viele wiederverwendbare Teile zu sichern und fachgerecht aufzubereiten.",
          "Durch diese Vorgehensweise senken wir das Abfallaufkommen, sparen Primärrohstoffe und minimieren unnötige CO₂-Emissionen, die bei der Herstellung neuer Teile entstehen würden. Alle Schritte erfolgen gemäß den geltenden Umweltvorgaben – transparent dokumentiert und fachgerecht umgesetzt. Vertrauen Sie auf unsere Expertise in der Autoverwertung Sankt Augustin für eine nachhaltige Fahrzeugverwertung!"
        ]}
            image={"/images/cars/11.png"}
      />

      <ContentSection
        id="jetzt-angebot-sichern"
        title="Jetzt Angebot sichern – Ihr direkter Einstieg in die Autoverwertung Sankt Augustin"
        description={[
          "Profitieren Sie von klaren Vorteilen ohne unnötigen Aufwand: feste Auszahlung ohne Preisrunden, kostenlose Abholung, rechtssichere Abmeldung und lückenlose Dokumentation – alles aus einer Hand.",
          "Holen Sie sich jetzt Ihr unverbindliches Angebot und tauschen Sie hohe Standkosten, Inserate und Terminchaos gegen planbare Auszahlungen und transparente Nachweise. Auch im Bereich Autoverschrottung Sankt Augustin und Autoentsorgung Sankt Augustin bieten wir Ihnen einen schnellen, professionellen und unkomplizierten Service. Wenn Sie einen Schrottplatz in der Nähe suchen, sind wir Ihr direkter Ansprechpartner in Sankt Augustin.",
          "Beginnen Sie noch heute mit der Autoverwertung Sankt Augustin!"
        ]}
            image={"/images/cars/12.png"}
      />


      <FAQ sectionId="faq" faqs={[
        {
          "question": "Wie funktioniert die Autoverwertung?",
          "answer": "Unser Verwertungsprozess beginnt mit der Begutachtung Ihres Fahrzeugs. Wir zahlen Ihnen einen fairen Preis in bar. Danach kümmern wir uns um die komplette Abwicklung, einschließlich Abholung, Demontage und umweltgerechter Entsorgung aller Komponenten."
        },
        {
          "question": "Welche Fahrzeuge nehmen Sie an?",
          "answer": "Wir kaufen alle Arten von Fahrzeugen: PKW, Lieferwagen, Transporter, Nutzfahrzeuge, beschädigte Autos, Unfallwagen und Schrottautos. Egal in welchem Zustand sich Ihr Fahrzeug befindet, wir finden eine Lösung."
        },
        {
          "question": "Ist die Abholung kostenlos?",
          "answer": "Ja, die Abholung ist bundesweit kostenlos. Wir holen Ihr Fahrzeug direkt bei Ihnen ab – schnell, zuverlässig und völlig kostenlos."
        },
        {
          "question": "Wie schnell erhalte ich mein Geld?",
          "answer": "Sie erhalten Ihr Geld in bar sofort nach der Begutachtung und Vereinbarung. Keine versteckten Gebühren, keine Verzögerungen."
        },
        {
          "question": "Warum ist unsere Lösung besser als ein Schrottplatz in der Nähe?",
          "answer": "Im Gegensatz zu einem klassischen Schrottplatz in der Nähe erhalten Sie bei uns eine komplette Abwicklung mit Bewertung, kostenlose Abholung, Abmeldung und direkter Auszahlung aus einer Hand."
        },
        {
          "question": "Wie kann ich in Sankt Augustin mein Schrottauto los werden?",
          "answer": "Wenn Sie schnell und unkompliziert Ihr Schrottauto los werden möchten, übernehmen wir in Sankt Augustin die Bewertung, kostenlose Abholung, fachgerechte Verwertung und die komplette Abwicklung für Sie."
        },
        {
          "question": "Was versteht man unter Autoentsorgung in Sankt Augustin?",
          "answer": "Unter Autoentsorgung Sankt Augustin versteht man die fachgerechte Entsorgung von alten, defekten oder nicht mehr fahrbereiten Fahrzeugen. Dabei werden verwertbare Teile ausgebaut und Schadstoffe umweltgerecht entfernt."
        }
      ]} />

      <AdditionalService
        sectionId="zusatzservices"
        cards={[
          {
            image: '/images/Barzahlung.png',
            title: 'Barzahlung',
            description: 'Die Barzahlung erfolgt bei der Fahrzeugübergabe wahlweise per Echtzeitüberweisung oder in bar.',
            button: { name: 'Fahrzeug verkaufen', link: '#contact-form' },
          },
          {
            image: '/images/Restwertermittlung.png',
            title: 'Restwertermittlung',
            description: 'Mit einer unverbindlichen Fahrzeugbewertung lässt sich der aktuelle Restwert des Autos einschätzen.',
            button: { name: 'Auto kostenlos bewerten', link: '#contact-form' },
          },
          {
            image: '/images/Kostenlose.png',
            title: 'Kostenlose Abholung',
            description: 'Auch Fahrzeuge mit Motor-, Getriebe- oder Unfallschäden können unkompliziert verkauft werden.',
            button: { name: 'Notverkauf starten', link: '#contact-form' },
          },
          {
            image: '/images/Unfallwagen-Ankauf.png',
            title: 'Unfallwagen-Ankauf',
            description: 'Verkaufen Sie Ihren Wagen trotz Motor- oder Getriebsschaden sicher und unkompliziert.',
            button: { name: 'Unfallauto verkaufen', link: '#contact-form' },
          },
          {
            image: '/images/Autoankauf-ohne-TÜV.png',
            title: 'Autoankauf ohne TÜV',
            description: 'Ein fehlender oder abgelaufener TÜV stellt beim Fahrzeugverkauf kein Hindernis dar.',
            button: { name: 'Jetzt PKW verkaufen', link: '#contact-form' },
          },
          {
            image: '/images/Autoexport.png',
            title: 'Autoexport',
            description: 'Auch Fahrzeuge mit hoher Laufleistung, teschnischen Defekten oder ohne gültigen TÜV können häufig noch weiterverwertet werden.',
            button: { name: 'Autoexport anfragen', link: '#contact-form' },
          },
        ]}
      />
      {/* Cookie Consent Popup */}
      <CookieConsent />
    </>
  )
}

